import type { ButtonHTMLAttributes } from 'react'

type ToolbarButtonProps = {
  isActive?: boolean
} & React.PropsWithChildren &
  ButtonHTMLAttributes<HTMLButtonElement>

export const ToolbarButton = ({ isActive, children, ...rest }: ToolbarButtonProps) => (
  <button
    {...rest}
    type="button"
    className={`cursor-pointer rounded border-none p-2 hover:bg-gray-200 ${isActive ? 'bg-gray-100' : 'bg-transparent'}`}
  >
    {children}
  </button>
)
